<div class="dialog-header mb-5">
	<div class="dialog-title">
		<h1 class="title mb-1" mat-dialog-title>
			{{ data.title }}
		</h1>
	</div>
</div>

<div mat-dialog-content class="import-content">
	<div>
		<p class="title">
			{{ data.description }}
		</p>
		<div class="slug-container">
			<div class="datasource-preview mb-2" *ngFor="let datasource of packageDataSources">
				<mat-icon>description</mat-icon>
				{{ datasource.name }} | {{ datasource.slug }}
			</div>
		</div>
	</div>

</div>

<div mat-dialog-actions class="dialog-footer">
	<button
		mat-button
		[mat-dialog-close]="null"
		color="secondary"
		class="submit margin-left-auto"
	>
		<ng-container i18n="Cancel Button@@dataImportDialogCancelButtonLabel">Cancel</ng-container>
	</button>

	<button
		mat-raised-button
		color="primary"
		class="submit margin-right-auto"
		(click)="submit()"
	>
		<ng-container i18n="Export Package Button@@adEditorExportPackageButton">Export Package</ng-container>
	</button>
</div>
